import MainLayout from "../../layouts/MainLayout/MainLayout";
import "./TermsAndConditionsPage.css";

export default function TermsAndConditionsPage() {
    return (
        <MainLayout>
            <div className="terms-container">
                <header className="terms-header">
                    <h1>Términos y Condiciones de Venta y Uso</h1>
                    <p className="last-update">Actualizado: Enero 2026</p>
                </header>

                <section className="terms-intro">
                    <p>
                        El presente documento establece las condiciones que regulan la compra de productos,
                        servicios y el uso de la plataforma de <strong>FORVET</strong>. Al realizar una compra en nuestro
                        sitio web, adquieres la condición de "Cliente" y aceptas estos términos en su totalidad.
                    </p>
                </section>

                <hr className="terms-divider" />

                <div className="terms-content">
                    <section className="terms-section">
                        <h2>1. Objeto y Contratación</h2>
                        <p>
                            FORVET ofrece servicios de formación y recursos educativos especializados. La contratación se perfecciona
                            en el momento en que se confirma el pago a través de nuestras pasarelas autorizadas.
                            Tras la compra, el cliente recibirá las credenciales de acceso al contenido digital
                            en el correo electrónico proporcionado.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>2. Propiedad Intelectual y Derechos de Autor</h2>
                        <p>
                            Todo el contenido didáctico, materiales audiovisuales, documentos y recursos proporcionados en esta plataforma
                            son propiedad intelectual de los <strong>docentes y autores respectivos</strong>. FORVET actúa como plataforma
                            autorizada para la explotación comercial y distribución de dichos contenidos, en virtud de los acuerdos
                            individuales establecidos con cada profesional.
                        </p>
                        <p>
                            La adquisición de un curso otorga al cliente una licencia de uso personal, privada y no exclusiva.
                            <strong> Está estrictamente prohibida</strong> la reproducción total o parcial, comunicación pública,
                            distribución, transformación o cualquier otra forma de explotación no autorizada de estos materiales.
                            Cualquier infracción será tratada conforme a las normativas vigentes de propiedad intelectual.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>3. Política de Devoluciones y Reembolsos</h2>
                        <p>
                            <strong> Derecho de arrepentimiento.</strong> <br />Las compras realizadas a través de nuestros canales online pueden revocarse dentro de los 10 días corridos contados desde la fecha de pago, con devolución total del importe abonado, sin costo ni penalidad, conforme a la Ley 24.240 de Defensa del Consumidor.
                        </p>
                        <p>
                            <strong>Solicitudes fuera de ese plazo.</strong>
                            <br />
                            Vencidos los 10 días, o cuando la capacitación ya hubiera comenzado, cada caso se analiza de manera particular en función de los hechos expuestos. En estos supuestos, del monto a reintegrar podrán descontarse:</p>
                        <ul>
                            <li>los costos financieros y administrativos efectivamente incurridos y no reintegrables (por ejemplo, comisiones de la plataforma o pasarela de pago), y/o</li>
                            <li>la parte proporcional del servicio ya prestado al momento de la solicitud.</li>
                        </ul>
                        <br />
                        <p>
                            <strong>Planes de pago y continuidad de beneficios.</strong>
                            <br />
                            Algunos beneficios —bonificaciones, promociones o accesos especiales— se otorgan en el marco del plan de pago acordado, los cuales podrían verse afectados ante la falta de cumplimiento en los compromisos de pago. Sabemos que a veces pueden surgir imprevistos y estamos para acompañarte: si atraviesas una dificultad, escríbenos y buscaremos juntos la mejor solución.
                        </p>
                        <br />
                        <p>
                            <strong>Cómo solicitarlo</strong>
                            <br />
                            Toda solicitud de devolución o reclamo sobre un pago debe presentarse de manera formal y por escrito, debidamente justificada, al correo indicado más abajo.
                        </p>
                        <br />

                         <p>
                            <strong>Legislación aplicable</strong>
                            <br />
                           La presente política se rige por la legislación Argentina.
                        </p>
                    </section>

                    <section className="terms-contact-box">
                        <h3>Atención al Cliente y Reclamos</h3>
                        <p>
                            Para cualquier gestión administrativa, técnica o solicitud de devolución, por favor diríjase a:
                        </p>
                        <div className="contact-details">
                            <span className="email-label">Email:</span>
                            <a href="mailto:administracion@forvet.org" className="email-link"> administracion@forvet.org</a>
                        </div>
                        <p className="response-time">
                            * Nuestro compromiso es brindarte una solución rápida. Recibirás una respuesta en un plazo máximo de <strong>hasta 48hs hábiles</strong>.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>4. Normas de Convivencia y Acceso</h2>
                        <p>
                            El acceso al campus virtual requiere un comportamiento ético. FORVET se reserva el derecho de
                            suspender el acceso a usuarios que incurran en prácticas de piratería, compartan credenciales
                            de acceso con terceros o falten al respeto a los docentes y demás alumnos en los espacios de comunidad.
                        </p>
                    </section>
                </div>

                <footer className="terms-footer">
                    <p>© {new Date().getFullYear()} FORVET</p>
                </footer>
            </div>
        </MainLayout>
    );
}